import { Controller } from 'stimulus';
import 'lib/vendor/snowplow';
import { getCurrentUserState } from 'lib/helpers';

export default class SnowplowAnalyticsController extends Controller {
  connect(collector, app, trackResourceImpressions) {
    this.getResourceImpressions = this.getResourceImpressions.bind(this);
    this.trackResourceImpression = this.trackResourceImpression.bind(this);
    this.sp = window.snowplow;
    this.trackResourceImpressions = trackResourceImpressions;

    this.sp('newTracker', 'cf', collector, {
      appId: app,
      discoverRootDomain: true,
      eventMethod: 'beacon',
      contexts: {
        webPage: true,
        performanceTiming: true,
        gaCookies: true,
        geolocation: false,
      },
    });
    this.sp('setUserIdFromCookie', 'session_guid');
    this.sp('enableActivityTracking', 10, 10);
    this.sp('enableLinkClickTracking');
    this.sp('trackPageView', null, [], this.getCustomContexts);
    if (this.trackResourceImpressions) {
      window.addEventListener('turbolinks:load', this.getResourceImpressions);
    }
  }

  disconnect() {
    window.removeEventListener('turbolinks:load', this.getResourceImpressions);
  }

  getCustomContexts() {
    const userState = getCurrentUserState();

    return [{
      schema: 'iglu:com.eezy/user_state/jsonschema/1-0-0',
      data: userState,
    }];
  }

  getResourceImpressions() {
    const resources = document.querySelectorAll('[data-item-id]');
    if (resources) {
      resources.forEach(this.trackResourceImpression);
    }
  }

  trackResourceImpression(resourceEl) {
    const resourceID = resourceEl.getAttribute('data-item-id');
    this.sp('trackStructEvent', 'search', 'resource_impression', resourceID, '', '');
  }
}
